import {
  ANDROID_LINK,
  DISCORD_LINK,
  // TELEGRAM_LINK,
  TESTFLIGHT_LINK,
  // TWITTER_LINK,
} from "../constants";
import { cn } from "../utils/cn";
import { AndroidIcon } from "./Icons/AndroidIcon";
import { AppleIcon } from "./Icons/AppleIcon";
import { DiscordIcon } from "./Icons/DiscordIcon";
// import { TelegramIcon } from "./Icons/TelegramIcon";
// import { TwitterIcon } from "./Icons/TwitterIcon";
// import { AndroidIcon } from "./Icons/AndroidIcon";
// import { AppleIcon } from "./Icons/AppleIcon";

interface Props {
  className?: string;
}

export const NavBarConnect = (props: Props) => {
  const { className } = props;

  return (
    <div className={cn("flex items-center gap-x-4", className)}>
      {/* <a href={TWITTER_LINK} target="_blank" rel="noopener noreferrer">
        <TwitterIcon className="h-4 aspect-[1200/1226.37] text-white duration-200 hover:text-primary cursor-pointer" />
      </a> */}
      <a href={DISCORD_LINK} target="_blank" rel="noopener noreferrer">
        <DiscordIcon className="h-4 aspect-[500/385.892574] text-white duration-200 hover:text-primary cursor-pointer" />
      </a>
      {/* <a href={TELEGRAM_LINK} target="_blank" rel="noopener noreferrer">
        <TelegramIcon className="h-4 aspect-[667.187688/559.547939] text-white duration-200 hover:text-primary cursor-pointer" />
      </a> */}
      <a href={ANDROID_LINK} target="_blank" rel="noopener noreferrer">
        <AndroidIcon className="h-5 text-white duration-200 hover:text-primary cursor-pointer" />
      </a>
      <a href={TESTFLIGHT_LINK} target="_blank" rel="noopener noreferrer">
        <AppleIcon className="h-5 text-white duration-200 hover:text-primary cursor-pointer" />
      </a>
      <a
        href="https://basedapp.io/login"
        className="px-4 py-1.5 rounded-full transition-all duration-200 font-medium text-black hover:text-primary bg-white hover:bg-transparent border hover:border-primary text-xs leading-[0.813rem]">
        Login
      </a>
    </div>
  );
};
